import React, { FC } from 'react';
import { Box, Unstable_Grid2 as Grid } from '@mui/material';

import { ActivityTabs, Stats, TotalReach } from '../components';
import {
  PARTNER_LINE_CHART_HEIGHT,
  PARTNER_REACH_CHART_HEIGHT,
  PARTNER_REACH_CHART_LOADER_HEIGHT,
} from '../constants';

const ActivityPartnerProtected: FC = () => {
  return (
    <Box padding={2}>
      <Grid container direction="column" spacing={3} wrap="nowrap">
        <Grid container spacing={3}>
          <Grid xs={12} md={8}>
            <Stats chartHeight={PARTNER_LINE_CHART_HEIGHT} showInternal={false} />
          </Grid>
          <Grid xs={12} md={4}>
            <TotalReach
              chartHeight={PARTNER_REACH_CHART_HEIGHT}
              loaderHeight={PARTNER_REACH_CHART_LOADER_HEIGHT}
            />
          </Grid>
        </Grid>
        <Grid>
          <ActivityTabs showInternal={false} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ActivityPartnerProtected;
